import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OtpInput from 'react-otp-input';
import { authenticateUser } from '../../../actions/loginActions';
import CustomButton from '../../../components/CustomButton';
import { Link, Redirect } from 'react-router-dom';
import { get } from 'lodash';
import { openSnackBar } from '../../../actions/snackbarAction';

const Otp = () => {
  const [enteredOTP, setEnteredOtp] = useState('');
  const [attempts, setAttempts] = useState(2);
  const [redirectToHome, setRedirectToHome] = useState(false);
  const dispatch = useDispatch();
  const studentID = useSelector(state =>
    get(state, 'loginReducer.data.StudentID', {})
  );
  const otp = useSelector(state => get(state, 'loginReducer.data.OTP', {}));
  const isLoginLoading = useSelector(state =>
    get(state, 'loadingReducer.isLoginLoading', {})
  );
  const loginData = useSelector(state =>
    get(state, 'loginReducer.loginData', {})
  );
  const deviceId = useSelector(state =>
    get(state, 'loginReducer.loginData.deviceId')
  );
  useEffect(() => {
    if (enteredOTP.length === 6) {
      onLogin();
    }
  }, [enteredOTP]);
  const handleKeypress = e => {
    //it triggers by pressing the enter key
    let code = e.keyCode || e.which;
    if (code === 13) {
      onLogin();
    }
  };
  const onLogin = () => {
    let deviceIdParam = deviceId;
    if (!deviceIdParam) {
      deviceIdParam = Math.floor(100000000 + Math.random() * 900000000);
    }
    if (enteredOTP === otp) {
      authenticateUser(
        loginData.uid,
        loginData.pass,
        loginData.loginType,
        deviceId,
        'otp',
        studentID,
        dispatch
      ).then(() => {
        setRedirectToHome(true);
      });
    } else {
      dispatch(
        openSnackBar({
          message: 'Please enter valid OTP',
          severity: 'error'
        })
      );
    }
  };
  const resendOtp = () => {
    let deviceIdParam = deviceId;
    if (!deviceIdParam) {
      deviceIdParam = Math.floor(100000000 + Math.random() * 900000000);
    }
    authenticateUser(
      loginData.uid,
      loginData.pass,
      loginData.loginType,
      deviceId,
      null,
      null,
      dispatch
    );
    setAttempts(attempts - 1);
    setEnteredOtp('');
  };
  if (redirectToHome) {
    return <Redirect to="/" />;
  }

  return (
    <div className="form-wrapper">
      <div className="greeting">
        <h1 className="welcome">Phone Verification</h1>
        <p className="info">Enter OTP sent to your mobile number</p>
      </div>
      <OtpInput
        value={enteredOTP}
        onChange={val => {
          setEnteredOtp(val);
        }}
        numInputs={6}
        containerStyle="otpContainer"
        inputStyle="otpInput"
        focusStyle="otpFocusInput"
        onKeyPress={handleKeypress}
        shouldAutoFocus={true}
        isInputNum={true}
      />
      {attempts > 0 && (
        <div className="action flex-row flex-space-between">
          <Link className="otpText" onClick={resendOtp}>
            Resend OTP
          </Link>
          <div className="resendText">{attempts} Attempts Left</div>
        </div>
      )}

      <div className="mt-30">
        <CustomButton
          name="Verify"
          handler={onLogin}
          disabled={isLoginLoading}
          progressShow={isLoginLoading}
          className={isLoginLoading ? 'loading-btn' : ''}
        />
      </div>
      <div className="seprator">
        <span>or</span>
      </div>

      <p className="flex flex-center">
        <Link to="/login" className="secondary-link">
          Back to Login
        </Link>
      </p>
    </div>
  );
};
export default Otp;
